import { render, staticRenderFns } from "./TaskPhotosCard.vue?vue&type=template&id=caaee936&scoped=true"
import script from "./TaskPhotosCard.vue?vue&type=script&lang=js"
export * from "./TaskPhotosCard.vue?vue&type=script&lang=js"
import style0 from "./TaskPhotosCard.vue?vue&type=style&index=0&id=caaee936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaee936",
  null
  
)

export default component.exports